import React, {useEffect, useState} from "react";
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    FormControl, FormControlLabel,
    FormLabel,
    Grid, IconButton,
    InputAdornment, Radio, RadioGroup,
    TextField
} from "@material-ui/core";
import {Clear, Close} from "@material-ui/icons";
import isNumber from "is-number";
import type InspectionItem from "../../services/dto/InspectionItem";
import {useStylesDutOptions} from "../DutWizard/DutOptions";
import {Alert} from "@material-ui/lab";
import {inspectionService} from "../../services/InspectionService";
import type Inspection from "../../services/dto/Inspection";
import syncService from "../../services/async-api/SyncService";
import InspectionItemTask from "../../services/async-api/InspectionItemTask";
import {IoMdEye} from "react-icons/io";
import {TASK_ACTIONS, TASK_STATUS} from "../../services/async-api/InspectionItemTask";
import {DEFAULT_FLOORS} from "../../services/BaseDataService";
import Autocomplete from "@material-ui/lab/Autocomplete";

export interface CorrectionDialogProps {
    open: boolean;
    handleClose: () => void;
    inspection: Inspection
}

export const CorrectionDialog : React.FC<CorrectionDialogProps> = ({open, handleClose, inspection}) => {
    const [dutNumberFrom, setDutNumberFrom] = useState(0)
    const [dutNumberTo, setDutNumberTo] = useState(0)

    const [errorMessage, setErrorMessage] = useState()
    const [infoMessage, setInfoMessage] = useState();
    const [attributeToChange, setAttributeToChange] = useState('room')
    const classes = useStylesDutOptions();
    const [inspectionItemTasks : InspectionItemTask[], setInspectionItemTasks] = useState([])


    const [numberOfOldNames, setNumberOfOldNames] = useState(0);
    const [oldNames, setOldNames] = useState([]);
    const [oldNameFormatted, setOldNameFormatted] = useState('-')
    const [numberOfDutsToChange, setNumberOfDutsToChange] = useState(0)

    const [errorMessageNewValue, setErrorMessageNewValue] = useState()
    const [newValue, setNewValue] = useState('')


     useEffect(() => {
         if(!open) {
             setOldNames([])
             setOldNameFormatted('-')
             setNumberOfOldNames(0);
             setErrorMessage(undefined);
             setInfoMessage(undefined);
             setDutNumberTo(0)
             setDutNumberFrom(0)
             setErrorMessageNewValue(undefined)
             setNumberOfDutsToChange(0)
             setNewValue('')
         }
     },[open])

    const changeDutNumber = (evt) => {
        let value = evt.target.value;

        // Erlaube leere Eingaben
        if (value === '') {
            setDutNumberFrom('');
            return;
        }

        // Nur Zahlen erlauben
        if (!/^\d+$/.test(value)) {
            return;
        }

        // Länge bereits durch maxLength begrenzt
        if (value.length > 7) {
            return;
        }

        // Als Number speichern
        let numValue = parseInt(value);
        setDutNumberFrom(numValue);
    }

    const changeDutNumberTo = (evt) => {
        let value = evt.target.value;

        // Erlaube leere Eingaben
        if (value === '') {
            setDutNumberTo('');
            return;
        }

        // Nur Zahlen erlauben
        if (!/^\d+$/.test(value)) {
            return;
        }

        // Länge bereits durch maxLength begrenzt
        if (value.length > 7) {
            return;
        }

        // Als Number speichern
        let numValue = parseInt(value);
        setDutNumberTo(numValue);
    }

    const dutNumberPrefix = (dutNumber) => {
        // Wenn leer, zeige 7 Nullen
        if (!dutNumber || dutNumber === 0 || dutNumber === '') {
            return '0000000';
        }

        // Berechne führende Nullen basierend auf aktueller Eingabelänge
        const inputLength = dutNumber.toString().length;
        const neededZeros = 7 - inputLength;

        if (neededZeros > 0) {
            return '0'.repeat(neededZeros);
        }

        // Wenn bereits 7 Zeichen, keine führenden Nullen
        return '';
    }

    useEffect(() => {
        if(dutNumberFrom && !dutNumberTo || dutNumberFrom > dutNumberTo) {
            setDutNumberTo(dutNumberFrom)
        }
    }, [dutNumberFrom]);

    const isNumber = require('is-number');
    useEffect(() => {
        setErrorMessage(null)
        setInfoMessage(null);
        if(!isNumber(dutNumberFrom) || !isNumber(dutNumberTo)) {
            setErrorMessage('Betriebsmittelnummern Von und Bis müssen jeweils Zahlen sein.')
            return;
        }
        if(dutNumberFrom > dutNumberTo) {
            setErrorMessage('Betriebsmittelnummer Bis ist kleiner als Betriebsmittelnummer Von.')
            return;
        }
        if(dutNumberTo >= dutNumberFrom) {
            const items : InspectionItemTask[] = [];
            for (let currentNumber = dutNumberFrom; currentNumber <= dutNumberTo; currentNumber++) {
                const item = syncService.findInspectionItem(currentNumber);
                if(item) {
                    items.push(item);
                }
            }
            setInspectionItemTasks(items)
            setNumberOfDutsToChange(items.length)
            if(items.length > 0) {
                setInfoMessage(<>Für diese Auswahl gefundene Prüflinge: <b>{items.length}</b></>);
            } else {
                setErrorMessage(<>Für die Auswahl wurden <b>keine</b> Prüflinge gefunden.</>);
            }
        }
    }, [dutNumberFrom, dutNumberTo]);

    useEffect(() => {
        let oldNames = null
        const oldValuesArr = [...new Set(inspectionItemTasks.map(value => attributeToChange === 'room' ? value.inspectionItem.room : value.inspectionItem.floor))]
        if(oldValuesArr.length > 1) {
            oldNames = 'Verschiede Werte';
        } else if (oldValuesArr.length === 1) {
            oldNames = oldValuesArr[0];
        } else {
            oldNames = '-'
        }
        setOldNames(oldValuesArr);
        setNumberOfOldNames(oldValuesArr.length);
        setOldNameFormatted(oldNames);

    }, [inspectionItemTasks, attributeToChange]);

    const saveNewValue = () => {
        if(!newValue || newValue.length < 1) {
            setErrorMessageNewValue('Bitte neuen Wert eingeben')
        } else {
            setErrorMessageNewValue(null);
        }
        const answer = window.confirm(`Durch diese Aktion wird bei ${numberOfDutsToChange} Prüflinge(n) der Raum überschrieben. Soll der Raum zu '${newValue}' geändert werden?`)
        if(answer) {
            const tasks : InspectionItemTask[] = [];
            for (const inspectionItemTask of inspectionItemTasks) {
                const newTask = inspectionItemTask.clone();
                newTask.originalInspectionItem = inspectionItemTask.inspectionItem.clone();
                if(attributeToChange === 'room') {
                    newTask.inspectionItem.room = newValue;
                } else {
                    newTask.inspectionItem.floor = newValue;
                }

                tasks.push(newTask);
            }
            // alert('submitting tasks: ' + tasks.length);
            syncService.submitSyncTasks(tasks)
            handleClose();
        }
    }


    return (
        <Dialog fullWidth maxWidth={"sm"} open={open} onClose={() => {
            handleClose();
        }}>
            <DialogTitle>
                Prüflinge korrigieren
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    style={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12} style={{display: 'flex', placeContent: 'start'}}>
                        <FormControl>
                            <FormLabel id="demo-row-radio-buttons-group-label">Zu änderndes Attribut</FormLabel>
                            <RadioGroup
                                row
                                value={attributeToChange}
                                onChange={event => {
                                    setAttributeToChange(event.target.value)
                                }}
                            >
                                <FormControlLabel value="room" control={<Radio />} label="Raum" />
                                <FormControlLabel  value="floor" control={<Radio />} label="Etage" />
                                {/*<FormControlLabel disabled={true}  value="dut" control={<Radio />} label="Betriebsmittelnummer" />*/}
                                {/*<FormControlLabel disabled={true}  value="dut" control={<Radio />} label="Prüfergebnis" />*/}
                                {/*<FormControlLabel disabled={true}  value="dut" control={<Radio />} label="Gerätetyp" />*/}
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField variant={"outlined"} error={!!errorMessage} fullWidth value={dutNumberFrom} type={"text"}
                                       onChange={changeDutNumber} label={'Betriebsmittelnummer Von'}
                                       inputProps={{
                                           inputMode: "numeric",
                                           pattern: "[0-9]*",
                                           maxLength: 7
                                       }}
                                       InputProps={{
                                startAdornment: <InputAdornment position={'start'} className={classes.dutNumberInputAdornment}>{dutNumberPrefix(dutNumberFrom)}</InputAdornment>,
                                endAdornment: (dutNumberFrom !== '' && dutNumberFrom !== 0) ? (
                                    <InputAdornment position={'end'}>
                                        <IconButton onClick={() => setDutNumberFrom('')} size={'small'}>
                                            <Clear />
                                        </IconButton>
                                    </InputAdornment>
                                ) : null
                            }}></TextField>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField variant={"outlined"} error={!!errorMessage} fullWidth value={dutNumberTo} onChange={changeDutNumberTo}
                                        label={'Betriebsmittelnummer Bis'}
                                        inputProps={{
                                            inputMode: "numeric",
                                            pattern: "[0-9]*",
                                            maxLength: 7
                                        }}
                                        InputProps={{
                                startAdornment: <InputAdornment position={'start'} className={classes.dutNumberInputAdornment}>{dutNumberPrefix(dutNumberTo)}</InputAdornment>,
                                endAdornment: (dutNumberTo !== '' && dutNumberTo !== 0) ? (
                                    <InputAdornment position={'end'}>
                                        <IconButton onClick={() => setDutNumberTo('')} size={'small'}>
                                            <Clear />
                                        </IconButton>
                                    </InputAdornment>
                                ) : null
                            }}></TextField>
                        </Grid>

                    {errorMessage && (
                        <Grid item xs={12}>
                            <Alert severity={'error'}>
                                {errorMessage}
                            </Alert>
                        </Grid>
                    )}
                    {infoMessage && (
                        <Grid item xs={12}>
                            <Alert severity={'info'}>
                                {infoMessage}
                            </Alert>
                        </Grid>
                    )}
                    <Grid item xs={6}>
                        <TextField value={oldNameFormatted} fullWidth variant={"outlined"}  InputProps={{
                            readOnly: true,
                            endAdornment: numberOfOldNames > 1 && <IconButton onClick={() => {
                                alert('Für die ausgewählten Prüflinge sind bisher folgende Räume gespeichert: \n\n' + oldNames.join('\n'))
                            }}><IoMdEye /></IconButton>
                        }} label={'Wert(e) alt'}></TextField>
                    </Grid>
                    <Grid item xs={6}>
                        {attributeToChange === 'room' && (
                            <TextField value={newValue} onChange={event => {
                                setNewValue(event.target.value)
                                if(event.target.value && event.target.value.length > 0)  {
                                    setErrorMessageNewValue(undefined)
                                } else {
                                    setErrorMessageNewValue('Bitte neuen Wert eingeben')
                                }
                            }} fullWidth variant={"outlined"} disabled={!!errorMessage} error={!!errorMessageNewValue} helperText={errorMessageNewValue} label={'Raum neu'}></TextField>
                        )}
                        {attributeToChange === 'floor' && (
                            <Autocomplete
                                options={DEFAULT_FLOORS.map((option) => option.title)}
                                value={newValue}
                                inputValue={newValue}
                                onInputChange={(event) => {
                                    setNewValue(event.target.value)
                                }}
                                onChange={(event, value) => {
                                    setNewValue(value)
                                }}
                                style={{width: '100%', display: 'inline-block'}}
                                renderInput={(params) =>
                                    <TextField  error={!!errorMessageNewValue} helperText={errorMessageNewValue} {...params} label="Neue Etage" variant="outlined"
                                                InputProps={{...params.InputProps, type: 'search'}}/>
                                }
                                freeSolo={true}
                                disableClearable={true}
                            >
                            </Autocomplete>
                        )}

                    </Grid>
                    <Grid item xs={12}>
                        <Button onClick={saveNewValue} fullWidth variant={'contained'} color={'primary'} disabled={!!errorMessage || !!errorMessageNewValue}>Änderung speichern</Button>
                    </Grid>

                </Grid>
            </DialogContent>
        </Dialog>
    )
}